import List from './views/List.vue'
import Create from './views/Create.vue'

export const ReversePayrollsRoutes = [
  {
    path: '/reverse-payrolls',
    name: 'ListReversePayrolls',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'reverse-request:list'
    }
  },
  {
    path: '/reverse-payroll/',
    name: 'CreateReversePayroll',
    component: Create,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'reverse-request:create'
    }
  }
]
